<template>
    <div class="icon-info pr-sm">
        <p>{{content}}</p>
  </div>
</template>

<script>
export default {
  name: 'NotificationIcon',
  props: ['content'],
};
</script>

<style scoped>
.icon-info{
    color:red;	
	font-size: 17px;
	line-height: normal;
	margin-left: 1rem;
}

.icon-info:hover p{
    display:block;
    transform-origin: 100% 0%;
    -webkit-animation: fadeIn 0.3s ease;
    animation: fadeIn 0.3s ease;
}

.icon-info p {    
	display: none;
	font-family: sans-serif;
	text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
	text-align: center;
	background-color: #FFFFFF;
	padding: 8px 5px;
	width: 178px;
	height: auto;
	position: absolute;
	left: 50%;
	transform: translate(-50%, -180%);
	border-radius: 3px;
	box-shadow: 0 0px 20px 0 rgba(0,0,0,0.1);
	color: #37393D;
	font-size: 12px;
	line-height: 18px;
	z-index: 99;
}

.icon-info p:after {
	width: 10px;
	height: 40px;
	content:'';
	position: absolute;
	top: -40px;
	left: 0;
}

@-webkit-keyframes fadeIn {
    0% { opacity:0; }
    100% { opacity:100%; }
}

@keyframes fadeIn {
    0% { opacity:0; }
    100% { opacity:100%; }
}
</style>



// WEBPACK FOOTER //
// NotificationIcon.vue?47bb106b